import styled from 'styled-components';
import { DialogActions } from '@material-ui/core';
import { COLORS } from 'constants/design';

export const StyledContainer = {
  padding: '8px 16px 8px 16px',
  border: '1px solid #0075C9',
  borderRadius: '92px',
  backgroundColor: '#FFFFFF',
  marginTop: '-40px',
  cursor: 'pointer',
};
export const StyledElement = {
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: '#0075C9',
  marginLeft: 3,
  marginTop: '-3px',
};
export const StyledIcon = {
  display: 'flex',
  marginTop: '-28px',
  marginLeft: '10px',
  cursor: 'pointer',
};
export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;
  .primary-button-style {
    border: 1px solid ${COLORS.BLUE_MENU_PRIMARY};
    background-color: ${COLORS.BLUE_MENU_PRIMARY} !important;
    color: ${COLORS.LIMED_SPURCE};
    &:hover {
      background-color: ${COLORS.BLUE_MENU_PRIMARY};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;

export const StyledDialogContent = { width: '500px' };
export const StyledFormControl = {
  width: '100%',
  marginBottom: '33px',
  fontSize: '13px',
};
export const StyledChip = {
  color: COLORS.WHITE,
  fontWeight: 700,
  backgroundColor: COLORS.BLUE_MENU_PRIMARY,
  borderWidth: 1,
  marginLeft: 10,
};
export const StyledOrangeChip = {
  color: COLORS.WHITE,
  fontWeight: 700,
  backgroundColor: 'rgb(194, 140, 35)',
  borderWidth: 1,
  marginLeft: 10,
};

export const StyledPinIcon = {
  height: '20px',
  width: '20px',
  marginRight: '8px',
  cursor: 'pointer',
  color: COLORS.BLUE_MENU_PRIMARY,
};
